import { render, staticRenderFns } from "./DataImmediateBosses.vue?vue&type=template&id=00566458"
import script from "./DataImmediateBosses.vue?vue&type=script&lang=js"
export * from "./DataImmediateBosses.vue?vue&type=script&lang=js"
import style0 from "./DataImmediateBosses.vue?vue&type=style&index=0&id=00566458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports